<template>
    <div>
		<EditProductClass
			v-if="modalProductClass"
			:productClassData="{}"
			@closeModal="closeProductClass"
			@newProductClass="setProductClass"
			:name="nameProductClass"
		/>
		<b-modal
			ref="modalEdit"
			hide-footer
			:title="titleModal"
			size="md"
			no-close-on-backdrop
			hide-header-close
			hide-header
		>
			<div class="title-modal">
				<div class="title-text-modal">{{ titleModal }}</div>
				<div
					class="float-right btn-hover-modal"
					@click="closeModal()"
				>
					<xIcon/>
				</div>
			</div>
			<div class="modal-edicao mb-3 modal-edicao-label mt-6">
				<b-tabs ref="tabs" class="text-parcela" style="height: 60vh;">
					<b-tab title="Geral" class="p-2 border border-top-none">
						<b-row class="mb-1">
							<b-col class="d-block text-parcela">
								<p class="label-conta">Produto/Serviço</p>
								<b-form-input
									name="description-produto"
									class="modal-edicao-input"
									type="text"
									v-model="productSelected.description"
									autocomplete="off"
									placeholder="Digite o nome do produto"
									v-validate="'required|maxLength:100'"
									:state="validateState('description-produto')"
								/>
							</b-col>
						</b-row>
						<b-row class="mb-1">
							<b-col class="d-block text-parcela">
								<p class="label-conta">Referência</p>
								<b-form-input
									name="reference-conta"
									class="modal-edicao-input"
									type="text"
									v-model="productSelected.reference"
									autocomplete="off"
									placeholder=""
									v-validate="'maxLength:100'"
									:state="validateState('reference-conta')"
								/>
							</b-col>
						</b-row>
						<b-row class="mb-1">
							<b-col class="d-block text-parcela">
								<p class="label-conta">Tipo de Produto</p>
								<SearchSelect
									name="productClass"
									:options="productClass.map((item) => {
										return {
											text: item.description,
											value: item.idProductClass
										}
									})"
									:visibleSuggestion="visibleSuggestion.productClass"
									:isMobile="isMobile"
									:newRecord="newProductClass"
									@changeSelect="changeSelect"
									@handleSuggestion="handleVisibleSuggestion"
									@invalidSearch="validateOptionSearch"
								/>
							</b-col>
						</b-row>
						<b-row class="mb-1">
							<b-col cols=3 class="d-block text-parcela center mr-0 pr-0">
								<p class="label-conta">Eventual</p>
								<ToggleSwitch
									name="eventual"
									class="toggle-conta"
									:value="productSelected.eventual"
									@toggle="_ => changeToggle('eventual')"
								/>
							</b-col>
							<b-col cols=3 class="d-block text-parcela center mr-0 pr-0 pl-1" v-if="!productSelected.eventual && showComposed">
								<p class="label-conta">Composto</p>
								<ToggleSwitch
									name="composed"
									class="toggle-conta"
									:value="productSelected.composed"
									@toggle="_ => changeToggle('composed')"
								/>
							</b-col>
							<b-col v-if="!productSelected.eventual" class="d-block text-parcela pl-1">
								<p class="label-conta">Código Barras</p>
								<b-form-input
									name="barcode-produto"
									class="modal-edicao-input"
									type="text"
									pattern="[0-9]*"
									inputmode="numeric"
									v-model="productSelected.barcode"
									autocomplete="off"
									placeholder=""
									v-validate="'maxLength:30'"
									:state="validateState('barcode-produto')"
									oninput="this.value = this.value.replace(/[^0-9]/g, '');"
								/>
							</b-col>
						</b-row>
					</b-tab>
					<b-tab title="Estoque" class="p-2 border border-top-none">
						<b-row v-if="!productSelected.eventual && !isServiceType" class="mb-1">
							<b-col cols=4 class="d-block text-parcela mr-0 pr-0">
								<p class="label-conta">Quantidade</p>
								<b-form-input
									name="quantity-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.quantity"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('quantity-produto')"
									@input="updateValue('quantity')"
									@focus="handleFocus('quantity')"
									@blur="handleBlur('quantity')"
								/>
							</b-col>
							<b-col cols=4 class="d-block text-parcela mr-0 pr-0 pl-1">
								<p class="label-conta">Mínimo</p>
								<b-form-input
									name="minQty-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.minQty"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('minQty-produto')"
									@input="updateValue('minQty')"
									@focus="handleFocus('minQty')"
								/>
							</b-col>
							<b-col cols=4 class="d-block text-parcela pl-1">
								<p class="label-conta">Máximo</p>
								<b-form-input
									name="maxQty-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.maxQty"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('maxQty-produto')"
									@input="updateValue('maxQty')"
									@focus="handleFocus('maxQty')"
								/>
							</b-col>
						</b-row>
						<b-row class="mb-1">
							<b-col cols=4 class="d-block text-parcela mr-0 pr-0">
								<p class="label-conta">Custo Anterior</p>
								<b-form-input
									name="previousCost-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.previousCost"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('previousCost-produto')"
									@input="updateValue('previousCost')"
									@focus="handleFocus('previousCost')"
								/>
							</b-col>
							<b-col cols=4 class="d-block text-parcela mr-0 pr-0 pl-1">
								<p class="label-conta">Custo Médio</p>
								<b-form-input
									name="averageCost-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.averageCost"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('averageCost-produto')"
									@input="updateValue('averageCost')"
									@focus="handleFocus('averageCost')"
								/>
							</b-col>
							<b-col cols=4 class="d-block text-parcela pl-1">
								<p class="label-conta">Custo Atual</p>
								<b-form-input
									name="currentCost-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.currentCost"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('currentCost-produto')"
									@input="updateValue('currentCost')"
									@focus="handleFocus('currentCost')"
								/>
							</b-col>
						</b-row>
						<b-row v-if="sale1" class="mb-1">
							<b-col class="d-block text-parcela mr-0 pr-0">
								<p class="label-conta">Preço de Revendedor</p>
								<b-form-input
									name="sale1-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.sale1"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('sale1-produto')"
									@input="updateValue('sale1')"
									@focus="handleFocus('sale1')"
								/>
							</b-col>
							<b-col cols="4" class="d-block text-parcela pl-1">
								<p class="label-conta">Porcentagem</p>
								<b-form-input
									name="percentage1-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.percentage1"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('percentage1-produto')"
									@input="updateValue('percentage1')"
									@focus="handleFocus('percentage1')"
								/>
							</b-col>
						</b-row>
						<b-row v-if="sale2" class="mb-1">
							<b-col class="d-block text-parcela mr-0 pr-0">
								<p class="label-conta">Preço de Atacado</p>
								<b-form-input
									name="sale2-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.sale2"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('sale2-produto')"
									@input="updateValue('sale2')"
									@focus="handleFocus('sale2')"
								/>
							</b-col>
							<b-col cols="4" class="d-block text-parcela pl-1">
								<p class="label-conta">Porcentagem</p>
								<b-form-input
									name="percentage2-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.percentage2"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('percentage2-produto')"
									@input="updateValue('percentage2')"
									@focus="handleFocus('percentage2')"
								/>
							</b-col>
						</b-row>
						<b-row v-if="sale3" class="mb-1">
							<b-col class="d-block text-parcela mr-0 pr-0">
								<p class="label-conta">Preço de Varejo</p>
								<b-form-input
									name="sale3-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.sale3"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('sale3-produto')"
									@input="updateValue('sale3')"
									@focus="handleFocus('sale3')"
								/>
							</b-col>
							<b-col cols="4" class="d-block text-parcela pl-1">
								<p class="label-conta">Porcentagem</p>
								<b-form-input
									name="percentage3-produto"
									class="modal-edicao-input number-class"
									type="text"
									inputmode="numeric"
									v-model="productSelected.percentage3"
									autocomplete="off"
									placeholder=""
									v-validate="{ required: false }"
									:state="validateState('percentage3-produto')"
									@input="updateValue('percentage3')"
									@focus="handleFocus('percentage3')"
								/>
							</b-col>
						</b-row>
					</b-tab>
					<b-tab v-if="showTaxe" title="Tributos" class="p-2 border border-top-none">
						<div class="table-responsive table-funcionalidades">
							<table class="table table-hover condensed text-parcela" data-cy="Tabela" :data-asc="true">
								<thead class="label-contaa">
									<tr>
										<th>Habilitado</th>
										<th>Tributo</th>
										<th>Descrição</th>
									</tr>
								</thead>
								<tbody class="table-td-taxe">
									<tr v-for="(item, idx) in productSelected.productTaxe" :key="idx">
										<td v-if="item.visible">
											<ToggleSwitch
												:name="`taxe-${item.idTaxe}`"
												:ref="`taxe-${item.idTaxe}`"
												:value="item.habilitado"
												@toggle="_ => changeTaxe(idx)"
											/>
										</td>
										<td v-if="item.visible">
											{{ item.name }}
										</td>
										<td v-if="item.visible">
											{{ item.description }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</b-tab>
				</b-tabs>
			</div>
			<b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal()">Cancelar</b-button>
			<b-button class="mt-3 float-left btn-modal btn-limpar" @click="cleanModal()">Limpar</b-button>
			<b-button
				class="mt-3 ml-1 float-right btn-modal btn-salvar"
				@click="saveRecord"
				:disabled="invalidForm || saving || invalidSearch.productClass"
			>
				Salvar
			</b-button>
		</b-modal>
    </div>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { ProductService } from "@/services/product";
	import emitter from "@/eventBus.js";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { numberFormatted, stringToNumber, validateNumber, isNullValue } from "@/helpers/common";
	import { mapState } from "vuex";
	import SearchSelect from "@/components/SearchSelect.vue";
	import EditProductClass from "@/views/ProductClass/EditProductClass.vue";

	export default {
		components: {
			ToggleSwitch,
			SearchSelect,
			EditProductClass
		},

		props: {
			productData: {
				type: Object,
				required: false
			},
			name: {
				type: String,
				required: false
			},
			showTaxe: {
				type: Boolean,
				required: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				productService: new ProductService(),
				titleModal: "",
				loading: true,
				noEditProduct: false,
				showComposed: false,
				sale1: false,
				sale2: false,
				sale3: true,
				isServiceType: false,
				productsClass: [],
				taxes: [],
				productSelected: {
					idProduct: null,
					description: "",
					reference: "",
					barcode: "",
					idProductClass: null,
					quantity: 0,
					minQty: 0,
					maxQty: 0,
					composed: false,
					eventual: false,
					averageCost: 0,
					currentCost: 0,
					previousCost: 0,
					sale1: 0,
					percentage1: 0,
					sale2: 0,
					percentage2: 0,
					sale3: 0,
					percentage3: 0
				},
				invalidForm: true,
				saving: false,
				visibleSuggestion: {
					productClass: false
				},
				isMobile: false,
				nameProductClass: "",
				newProductClass: {},
				invalidSearch: {
					productClass: true
				},
				modalProductClass: false

			};
		},

		computed: {
			...mapState(["productClass", "taxe", "product"])
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			await this.findTaxes();
			await this.findProductClass();
			this.showProduct();
			this.loading = false;
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			async showProduct () {
				this.invalidForm = true;
				const { idProduct,
					barcode,
					description,
					reference,
					idProductClass,
					quantity,
					minQty,
					maxQty,
					composed,
					eventual,
					averageCost,
					currentCost,
					previousCost,
					sale1,
					percentage1,
					sale2,
					percentage2,
					sale3,
					percentage3
				} = this.productData;

				if (!idProduct) {
					this.productSelected.description = this.name;
					this.titleModal = "Cadastrar Novo Produto";
					this.noEditProduct = true;
				} else {
					this.productSelected.description = description || "";
					this.titleModal = "Editar Produto";
					this.noEditProduct = false;
					this.nameProductClass = (this.productClass.find(ele => ele.idProductClass === idProductClass))?.description || null;
					this.newProductClass = {
						id: idProductClass,
						description: this.nameProductClass
					};
				}

				this.productSelected.idProduct = idProduct || "";
				this.productSelected.barcode = barcode || "";
				this.productSelected.reference = reference || "";
				this.productSelected.idProductClass = idProductClass || null;
				this.productSelected.quantity = numberFormatted(quantity || 0);
				this.productSelected.minQty = numberFormatted(minQty || 0);
				this.productSelected.maxQty = numberFormatted(maxQty || 0);
				this.productSelected.composed = composed || false;
				this.productSelected.eventual = eventual || false;
				this.productSelected.averageCost = numberFormatted(averageCost || 0);
				this.productSelected.currentCost = numberFormatted(currentCost || 0);
				this.productSelected.previousCost = numberFormatted(previousCost || 0);
				this.productSelected.sale1 = numberFormatted(sale1 || 0);
				this.productSelected.percentage1 = numberFormatted(percentage1 || 0);
				this.productSelected.sale2 = numberFormatted(sale2 || 0);
				this.productSelected.percentage2 = numberFormatted(percentage2 || 0);
				this.productSelected.sale3 = numberFormatted(sale3 || 0);
				this.productSelected.percentage3 = numberFormatted(percentage3 || 0);
				this.validateProductClass(idProductClass);

				this.productSelected.productTaxe = this.taxes.map(pt => {
					pt.habilitado = this.productData.productTaxe ? this.productData.productTaxe.some(it => it.idTaxe === pt.idTaxe) : false;
					pt.visible = true;
					return pt;
				});
				this.$refs.modalEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			closeModal () {
				this.$refs.modalEdit.hide();
				this.cleanModal();
				this.productSelected.idProduct = "";
				this.saving = false;
				this.$emit("closeModal");
			},

			cleanModal () {
				this.productSelected.idProduct = null;
				this.productSelected.description = "";
				this.productSelected.reference = "";
				this.productSelected.barcode = "";
				this.productSelected.idProductClass = null;
				this.productSelected.quantity = 0;
				this.productSelected.minQty = 0;
				this.productSelected.maxQty = 0;
				this.productSelected.composed = false;
				this.productSelected.eventual = false;
				this.productSelected.averageCost = 0;
				this.productSelected.currentCost = 0;
				this.productSelected.previousCost = 0;
				this.productSelected.sale1 = 0;
				this.productSelected.percentage1 = 0;
				this.productSelected.sale2 = 0;
				this.productSelected.percentage2 = 0;
				this.productSelected.sale3 = 0;
				this.productSelected.percentage3 = 0;
				this.invalidForm = true;
			},

			async saveRecord () {
				if (await this.recordExist()) {
					return;
				}

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};
				const payload = {
					barcode: this.productSelected.barcode,
					description: this.productSelected.description,
					reference: this.productSelected.reference,
					idProductClass: this.productSelected.idProductClass,
					quantity: stringToNumber(this.productSelected.quantity),
					minQty: stringToNumber(this.productSelected.minQty),
					maxQty: stringToNumber(this.productSelected.maxQty),
					composed: this.productSelected.eventual ? false : this.productSelected.composed,
					eventual: this.productSelected.eventual,
					averageCost: stringToNumber(this.productSelected.averageCost),
					currentCost: stringToNumber(this.productSelected.currentCost),
					previousCost: stringToNumber(this.productSelected.previousCost),
					sale1: stringToNumber(this.productSelected.sale1),
					percentage1: stringToNumber(this.productSelected.percentage1),
					sale2: stringToNumber(this.productSelected.sale2),
					percentage2: stringToNumber(this.productSelected.percentage2),
					sale3: stringToNumber(this.productSelected.sale3),
					percentage3: stringToNumber(this.productSelected.percentage3),
					productTaxe: this.productSelected.productTaxe
				};

				if (this.productSelected.idProduct)
					payload.idProduct = this.productSelected.idProduct;

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						const newProduct = await this.productService.upsertProduct({payload});

						this.$emit("findProduct", true);
						this.$emit("newProduct", newProduct);
						emitter.emit("reloadProduct", { reload: true });
						this.closeModal();
						return {
							title: "Sucesso!",
							body: "Produto salvo com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar o produto!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async validateModal () {
				const validationFields = Object.keys(this.veeFields);
				if (!validationFields.length)
					return true;

				const validations = validationFields.reduce((acc, ref) => {
					if (this.veeFields[ref] && this.veeFields[ref].invalid)
						return [...acc, this.veeFields[ref].invalid];

					return acc;
				}, []);

				const invalidFields = validations.filter(field => field);
				return Boolean(invalidFields && invalidFields.length);
			},

			changeToggle (key) {
				this.productSelected[key] = !this.productSelected[key];
			},

			validateProductClass (idProductClass) {
				if (idProductClass) {
					const producClassSelect = this.productsClass.find(pc => pc.value === this.productSelected.idProductClass) || {};
					this.isServiceType = producClassSelect?.service === "Sim";
				}
			},

			handleFocus (key) {
				if (isNullValue(this.productSelected[key])) this.productSelected[key] = "";
			},

			handleBlur (key) {
				if (!this.productSelected[key]) {
					this.productSelected[key] = "0,00";
				} else {
					this.productSelected[key] = numberFormatted(stringToNumber(this.productSelected[key]));
				}
			},

			changeTaxe (idx) {
				const item = this.productSelected.productTaxe[idx];
				item.habilitado = !item.habilitado;
				//this.invalidForm = !this.productSelected.name;
			},

			filterTaxe (v) {
				const stringLength = v.length;
				this.productSelected.taxe.forEach((t) => {
					const string = t.name.substr(0, stringLength);
					if (stringLength > 0 && string.toLowerCase() !== v.toLowerCase())
						t.visible = false;
					else
						t.visible = true;

					return;
				});
			},

			async findTaxes () {
				if (!this.showTaxe) return;

				this.taxes = this.taxe.map((t) => ({ ...t, habilitado: false, visible: true }));
			},

			async findProductClass () {
				const limit = null;
				const offset = 0;
				const sortTable = {
					sortBy: 0,
					order: 1,
					query: ""
				};

				this.productsClass = this.productClass.reduce((acc, pc) => [
					...acc,
					{
						value: pc.idProductClass,
						text: pc.description,
						service: pc.service
					}
				], []);
			},

			async updateValue (key) {
				const value = this.productSelected[key];
				this.productSelected[key] = await validateNumber(value);

				const cost = stringToNumber(this.productSelected.currentCost);
				const valueAltered = stringToNumber(this.productSelected[key]);
				if (cost <= 0 || valueAltered <= 0 ) return;
				let newValue = 0;
				switch (key) {
					case "sale1":
						newValue = ((valueAltered - cost) / cost) * 100;
						this.productSelected.percentage1 = numberFormatted(newValue || 0);
						break;
					case "sale2":
						newValue = ((valueAltered - cost) / cost) * 100;
						this.productSelected.percentage2 = numberFormatted(newValue || 0);
						break;
					case "sale3":
						newValue = ((valueAltered - cost) / cost) * 100;
						this.productSelected.percentage3 = numberFormatted(newValue || 0);
						break;
					case "percentage1":
						newValue = (cost * valueAltered / 100) + cost;
						this.productSelected.sale1 = numberFormatted(newValue || 0);
						break;
					case "percentage2":
						newValue = (cost * valueAltered / 100) + cost;
						this.productSelected.sale2 = numberFormatted(newValue || 0);
						break;
					case "percentage3":
						newValue = (cost * valueAltered / 100) + cost;
						this.productSelected.sale3 = numberFormatted(newValue || 0);
						break;
					default:
						break;

				}
			},

			closeProductClass (cancelled) {
				if (cancelled) {
					this.nameProductClass = "";
				}

				this.modalProductClass = false;
			},

			setProductClass (newProductClass) {
				this.newProductClass = {
					id: newProductClass[0].idProductClass,
					description: newProductClass[0].description
				};

				this.productSelected.idProductClass = newProductClass[0].idProductClass;
				this.closingMonthly = newProductClass[0].closeMonthly;
			},

			showProductClass () {
				this.modalProductClass = true;
			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				this.nameProductClass = text;
				if (value) {
					this.productSelected.idProductClass = value;
					this.validateProductClass(this.productSelected.idProductClass);
				} else {
					this.showProductClass();
				}
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
			},

			handleVisibleSuggestion (handleSuggestion) {
				this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
			},

			async recordExist () {
				const recordExist = this.product.find(p => p.description === this.productSelected.description && this.productSelected.idProduct !== p.idProduct);
				if (recordExist) {
					await this.$swal({
						title: "Registro já existe",
						text: "Não é possível criar o registro, altere o nome e tente novamente.",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return true;
				}

				return false;
			}
		}
	};
</script>
